import { render } from "./OrderBicycle.vue?vue&type=template&id=4635535f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/OrderBicycle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4635535f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4635535f', __exports__)) {
    api.reload('4635535f', __exports__)
  }
  
  module.hot.accept("./OrderBicycle.vue?vue&type=template&id=4635535f", () => {
    api.rerender('4635535f', render)
  })

}


export default __exports__